import ModalDefault from './Modal.Default';
import VLDFormRequest from '../../modules/vld/VLD.Form.Request';

class ModalRequest extends ModalDefault {
  $form: HTMLFormElement;
  vldForm: any;
  public beforeMount() {
    super.beforeMount();
    this.$form = this.$modal.querySelector('form');
    this.vldForm = new VLDFormRequest(this.$form, false);
    return this;
  }

  public beforeOpen() {
    super.beforeOpen();
    this.vldForm.mountFields();
    return this;
  }

  public afterClose() {
    super.afterClose();
    const $success: HTMLElement = this.$form.querySelector('[data-success]');
    const $formContent: HTMLElement = this.$form.querySelector('[data-form-content]');
    this.vldForm.vldFields.forEach(vldField => vldField.unMount());
    this.$form.classList.remove('has-success', 'has-error');
    $success.style.display = '';
    $formContent.style.display = '';
    return this;
  }
}

export default ModalRequest;
